import React, { useState } from 'react';
import HowItWorks from '../UI/HowItsWorks';

const HowItWorksElevation = () => {


    const steps = [
        {
            number: 1,
            title: "Consultation & Design Brief",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2FHow_It_works%2FConsultation_and_Design_Brief.png?alt=media&token=401f5a24-4168-41aa-a6e2-ed7fa5972e75",
            description: "Schedule your project timeline"
        },
        
        {
            number: 2,
            title: "Strategic Planning",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2FHow_It_works%2FConcept_Development.png?alt=media&token=5eb868c7-add1-40d3-935a-e9fd7bf56eae",
            description: "Detailed cost estimation and portfolio presentation"
        },
        
        {
            number: 3,
            title: "Rendering & Detailing",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2FHow_It_works%2FRendering_and_Detailing.png?alt=media&token=0d6223f6-1092-499e-8ea8-56d6d1e25abd",
            description: "Comprehensive MEP system design and documentation"
        },
        {
            number: 4,
            title: "Review & Modification",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2FHow_It_works%2FClient_Review_and_Modifications.png?alt=media&token=506c2ba2-d6d8-4aa8-8a7d-4daf58350975",
            description: "Initial discussion about your project requirements and scope"
        },
        {
            number: 5,
            title: "Final Delivery",
            icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2F3D%2FHow_It_works%2FFinal_Delivery.png?alt=media&token=833e8110-55ee-4847-bc1e-e8b3a5f94adb   ",
            description: "Quality check and project delivery"
        }
    ];


    return (
        <>
            <HowItWorks steps={steps} />
        </>
    );
};

export default HowItWorksElevation;
